(() => {
  const CARD_SELECTOR = ".qp-media-card";
  const BTN_SELECTOR = ".qp-media-card__play";
  const VIDEO_SELECTOR = "video.qp-media-card__video";

  const getCardParts = (btn) => {
    const card = btn.closest(CARD_SELECTOR);
    if (!card) return null;
    const video = card.querySelector(VIDEO_SELECTOR);
    if (!video) return null;
    return { card, btn, video };
  };

  const setState = ({ card, btn, video }) => {
    const playing = !video.paused && !video.ended;
    card.classList.toggle("is-playing", playing);
    btn.setAttribute("aria-label", playing ? "Pause video" : "Play video");
  };

  // One click listener for all cards (event delegation)
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(BTN_SELECTOR);
    if (!btn) return;

    const parts = getCardParts(btn);
    if (!parts) return;

    // Keep existing behavior: don’t follow link / don’t bubble
    e.preventDefault();
    e.stopPropagation();

    const { video } = parts;

    if (video.paused || video.ended) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }

    setState(parts);
  });

  // Keep UI in sync if playback state changes (keyboard, autoplay policies, etc.)
  document.addEventListener("play", (e) => {
    if (!(e.target instanceof HTMLVideoElement)) return;
    if (!e.target.matches(VIDEO_SELECTOR)) return;

    const card = e.target.closest(CARD_SELECTOR);
    if (!card) return;
    const btn = card.querySelector(BTN_SELECTOR);
    if (!btn) return;

    setState({ card, btn, video: e.target });
  }, true);

  document.addEventListener("pause", (e) => {
    if (!(e.target instanceof HTMLVideoElement)) return;
    if (!e.target.matches(VIDEO_SELECTOR)) return;

    const card = e.target.closest(CARD_SELECTOR);
    if (!card) return;
    const btn = card.querySelector(BTN_SELECTOR);
    if (!btn) return;

    setState({ card, btn, video: e.target });
  }, true);

  document.addEventListener("ended", (e) => {
    if (!(e.target instanceof HTMLVideoElement)) return;
    if (!e.target.matches(VIDEO_SELECTOR)) return;

    const card = e.target.closest(CARD_SELECTOR);
    if (!card) return;
    const btn = card.querySelector(BTN_SELECTOR);
    if (!btn) return;

    setState({ card, btn, video: e.target });
  }, true);

  // Initialize current state once (covers cases where videos start paused, etc.)
  const init = () => {
    document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      const btn = card.querySelector(BTN_SELECTOR);
      const video = card.querySelector(VIDEO_SELECTOR);
      if (!btn || !video) return;
      setState({ card, btn, video });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
